import {
  StudioIdIcon,
  UsernameIcon,
  SubscriptionStatusIcon,
  EmailAddressIcon,
  CurrentStudioVersionIcon,
  LastUpdatedIcon,
  LastCommunicatedIcon,
  TotalCamerasIcon,
  RamIcon,
  GPUIcon,
  StorageIcon,
  ProcessorIcon,
  ForcePlateIcon,
  AllTimeIcon,
  TwentyFourHoursIcon,
  OneWeekIcon,
  OneMonthIcon,
  SixMonthIcon,
  OneYearIcon,
  DateCaptureIcon,
  CaptureQualityIcon,
  VideoCreattionTimeIcon,
  UploadTimeIcon,
  WaitingTimeIcon,
  ProcessingTimeIcon,
  VisualizationTimeIcon,
  TimeToUserIcon,
  TotalStrikersIcon,
  TotalwithActiveIcon,
  EstimatedSalesIcon,
  UploadSpeedIcon,
  DownloadSpeedIcon,
  CrossIcon,
  SmileIcon,
  CaptureHeaderIcon,
  CourtIcon,
  CaseAlertIcon,
  EuroIcon,
  CalenderIconNew,
  InsuranceCarIcon,
  AddressIcon,
  LicensePlateIcon,
  ModelCarIcon,
  CarDisplacementIcon,
  FormHouseIcon,
  HouseIconChild,
  ZipCodeChildIcon,
  CityIconChild,
  CountryIconChild,
  NameIconChild,
  CarCompanyIconChild,
  CarModelIconChild,
  DriverNameIconChild,
  RelationWithCustomerIconChild,
  StreetIconChild,
  StateIconChild,
  FileRefrenceIcon,
  CustomerNumberIcon,
  InvoiceNumberIcon,
  InvoiceDateIcon,
  PolicyHolderIcon,
  AssistantIcon,
  TypeOfDamage,
  CaseCreationDateIcon,
  LicensePlateSmileIcon,
  CaseCreatedByIcon,
  UndieIcon,
  AttorneyIcon,
  FormInsuranceIcon,
  CustomerIdIcon,
  Intermediary,
  CreatedByDateMasterIcon,
  CreatedByMasterIcon,
} from "icons";
import { getFormattedDate } from "utils/helpers";

export const infoData = {
  header: {
    heading: "Information",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      key: "studio_id",
      label: "Studio ID",
      value: "",
      LabelIcon: StudioIdIcon,
    },
    {
      id: 2,
      label: "Username",
      key: "username",
      value: "",
      LabelIcon: UsernameIcon,
    },
    {
      id: 3,
      label: "Subscription Status",
      key: "subscription_status",
      value: "",
      LabelIcon: SubscriptionStatusIcon,
      valueColor: "#F63E50",
    },
    {
      id: 4,
      label: "Email Address",
      key: "email",
      value: "alina.cris@gmail.com",
      LabelIcon: EmailAddressIcon,
    },
    {
      id: 5,
      label: "Current Studio Version",
      key: "current_version",
      value: "1.2.1",
      LabelIcon: CurrentStudioVersionIcon,
    },
    {
      id: 6,
      label: "Last Updated",
      key: "last_updated",
      value: "02.03.25",
      LabelIcon: LastUpdatedIcon,
    },
    {
      id: 7,
      label: "Last Communicated",
      key: "last_communicated",
      value: "03.03.25",
      LabelIcon: LastCommunicatedIcon,
    },
  ],
};

export function getUpdatedData({ apiObject, customData }) {
  if (!apiObject) return customData;

  const list = customData.list.map((item) => {
    let value = apiObject[item.key];
    value = item.key === "last_updated" ? getFormattedDate(value) : value;
    return {
      ...item,
      value,
    };
  });
  return { ...customData, list };
}

export const hardwareData = {
  header: {
    heading: "Hardware Specifications",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "Total Cameras",
      key: "cameras",
      value: "2",
      LabelIcon: TotalCamerasIcon,
    },
    {
      id: 2,
      label: "RAM",
      key: "ram",
      value: "64GB",
      LabelIcon: RamIcon,
    },
    {
      id: 3,
      label: "GPU",
      key: "gpu",
      value: "RTX 4090",
      LabelIcon: GPUIcon,
    },
    {
      id: 4,
      label: "Storage",
      key: "storage",
      value: "1TB",
      LabelIcon: StorageIcon,
    },
    {
      id: 5,
      label: "Processor",
      key: "processor",
      value: "Core i7",
      LabelIcon: ProcessorIcon,
    },
    {
      id: 6,
      label: "Force Plate",
      key: "force_plates",
      value: "",
      valueIcon: CrossIcon,
      LabelIcon: ForcePlateIcon,
    },
  ],
};
export const networkData = {
  header: {
    heading: "Network Specification",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "Upload Speed",
      value: "50MBPS",
      key: "upload_speed",
      LabelIcon: UploadSpeedIcon,
    },
    {
      id: 2,
      label: "Download Speed",
      key: "download_speed",
      value: "250MBPS",
      LabelIcon: DownloadSpeedIcon,
    },
  ],
};

export const captureData1 = {
  header: {
    heading: "Capture",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "All Time",
      value: "5000",
      LabelIcon: AllTimeIcon,
    },
    {
      id: 2,
      label: "24 Hrs",
      value: "05",
      LabelIcon: TwentyFourHoursIcon,
    },
    {
      id: 3,
      label: "1 Week",
      value: "05",
      LabelIcon: OneWeekIcon,
    },
    {
      id: 4,
      label: "1 Month",
      value: "190",
      LabelIcon: OneMonthIcon,
    },
    {
      id: 5,
      label: "6 Months",
      value: "800",
      LabelIcon: SixMonthIcon,
    },
    {
      id: 6,
      label: "1 Year",
      value: "4000",
      LabelIcon: OneYearIcon,
    },
  ],
};
export const captureData2 = {
  header: {
    heading: "Capture",
    icon: CaptureHeaderIcon,
  },
  list: [
    {
      id: 1,
      label: "Date",
      value: "04.03.25",
      LabelIcon: DateCaptureIcon,
    },
    {
      id: 2,
      label: "Capture Quality",
      value: "Excellent",
      LabelIcon: CaptureQualityIcon,
      isValueTag: true,
      tagIcon: SmileIcon,
    },
    {
      id: 3,
      label: "Video Creation Time",
      value: "12 sec",
      LabelIcon: VideoCreattionTimeIcon,
    },
    {
      id: 4,
      label: "Upload Time",
      value: "10 sec",
      LabelIcon: UploadTimeIcon,
    },
    {
      id: 5,
      label: "Waiting Time",
      value: "10 sec",
      LabelIcon: WaitingTimeIcon,
    },
    {
      id: 6,
      label: "Processing Time",
      value: "15 sec",
      LabelIcon: ProcessingTimeIcon,
    },
    {
      id: 7,
      label: "Visualization Time",
      value: "20 sec",
      LabelIcon: VisualizationTimeIcon,
    },
    {
      id: 8,
      label: "Time to User",
      value: "10 sec",
      LabelIcon: TimeToUserIcon,
    },
  ],
};
export const RevenueData = {
  header: {
    heading: "Revenue",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "Total Strikers",
      value: "10,000",
      LabelIcon: TotalStrikersIcon,
    },
    {
      id: 2,
      label: "Total Strikers with Active Subscriptions",
      value: "5000",
      LabelIcon: TotalwithActiveIcon,
    },
    {
      id: 3,
      label: "Estimated Sales",
      value: "€100,000",
      LabelIcon: EstimatedSalesIcon,
      valueColor: "#73BB1C",
    },
  ],
};
export const childKeys = {
  address: [
    {
      id: null,
      key: "street",
      label: "Street",
      value: "",
      type: "text",
      prefixIcon: StreetIconChild,
      parentKey: "address",
    },
    {
      id: null,
      key: "house",
      label: "House",
      value: "",
      type: "text",
      prefixIcon: HouseIconChild,
      parentKey: "address",
    },
    {
      id: null,
      key: "zipCode",
      label: "zipCode",
      value: "",
      type: "text",
      prefixIcon: ZipCodeChildIcon,
      parentKey: "address",
    },
    {
      id: null,
      key: "city",
      label: "city",
      value: "",
      type: "dropdown",
      prefixIcon: CityIconChild,
      parentKey: "address",
    },
    {
      id: null,
      key: "state",
      label: "State",
      value: "",
      type: "text",
      prefixIcon: StateIconChild,
      parentKey: "address",
    },
    {
      id: null,
      key: "country",
      label: "country",
      value: "Deutschland",
      type: "text",
      prefixIcon: CountryIconChild,
      dependentDropdownKey: "city",
      parentKey: "address",
    },
  ],
  customerName: [
    {
      id: null,
      key: "firstName",
      label: "firstName",
      value: "",
      type: "text",
      prefixIcon: NameIconChild,
      parentKey: "customerName",
    },
    {
      id: null,
      key: "lastName",
      label: "lastName",
      value: "",
      type: "text",
      prefixIcon: NameIconChild,
      parentKey: "customerName",
    },
  ],
  customerAddress: [
    {
      id: null,
      key: "street",
      label: "street",
      value: "",
      type: "text",
      prefixIcon: StreetIconChild,
      parentKey: "customerName",
    },
    {
      id: null,
      key: "house",
      label: "house",
      value: "",
      type: "text",
      prefixIcon: HouseIconChild,
      parentKey: "customerName",
    },
    {
      id: null,
      key: "zipCode",
      label: "zipCode",
      value: "",
      type: "text",
      prefixIcon: ZipCodeChildIcon,
      parentKey: "customerName",
    },
    {
      id: null,
      key: "city",
      label: "city",
      value: "",
      type: "dropdown",
      prefixIcon: CityIconChild,
      parentKey: "customerName",
      dropdownType: "city",
    },
    {
      id: null,
      key: "state",
      label: "state",
      value: "",
      type: "dropdown",
      prefixIcon: StateIconChild,
      parentKey: "customerName",
      dropdownType: "state",
    },
    {
      id: null,
      key: "country",
      label: "country",
      value: "Deutschland",
      type: "text",
      prefixIcon: CountryIconChild,
      parentKey: "customerName",
      dropdownType: "country",
    },
  ],
  modelVehicleUF: [
    {
      id: null,
      key: "carCompany",
      label: "carCompany",
      value: "",
      prefixIcon: CarCompanyIconChild,
      type: "dropdown",
      dependentDropdownKey: "carModel",
      parentKey: "modelVehicleUF",
      dropdownType: "carCompany",
    },
    {
      id: null,
      key: "carModel",
      label: "carModel",
      value: "",
      prefixIcon: CarModelIconChild,
      type: "dropdown",
      parentKey: "modelVehicleUF",
      dropdownType: "carModel",
    },
  ],
  additionalDriverName: [
    {
      id: null,
      key: "driverFirstName",
      label: "driverFirstName",
      value: "",
      type: "text",
      prefixIcon: DriverNameIconChild,
      parentKey: "additionalDriverName",
    },
    {
      id: null,
      key: "driverLastName",
      label: "driverLastName",
      value: "",
      type: "text",
      prefixIcon: DriverNameIconChild,
      parentKey: "additionalDriverName",
    },
  ],
  relationToCustomer: [
    {
      id: null,
      key: "relationToCustomer",
      label: "Relationship To Customer",
      value: "",
      type: "dropdown",
      dropdownType: "relationToCustomer",
      prefixIcon: RelationWithCustomerIconChild,
      parentKey: "additionalDriverName",
    },
  ],
  locationVehicleHandover: [
    {
      id: null,
      key: "vHandoverLocationStreet",
      label: "vHandoverLocationStreet",
      value: "",
      type: "text",
      prefixIcon: StreetIconChild,
      parentKey: "locationVehicleHandover",
    },
    {
      id: null,
      key: "vHandoverLocationHouse",
      label: "vHandoverLocationHouse",
      value: "",
      type: "text",
      prefixIcon: HouseIconChild,
      parentKey: "locationVehicleHandover",
    },
    {
      id: null,
      key: "vHandoverLocationZipCode",
      label: "vHandoverLocationZipCode",
      value: "",
      type: "text",
      prefixIcon: ZipCodeChildIcon,
      parentKey: "locationVehicleHandover",
    },
    {
      id: null,
      key: "vHandoverLocationCity",
      label: "vHandoverLocationCity",
      value: "",
      type: "dropdown",
      prefixIcon: CityIconChild,
      parentKey: "locationVehicleHandover",
      dropdownType: "city",
    },
    {
      id: null,
      key: "vHandoverLocationState",
      label: "vHandoverLocationState",
      value: "",
      type: "dropdown",
      prefixIcon: StateIconChild,
      parentKey: "locationVehicleHandover",
      dropdownType: "state",
    },

    {
      id: null,
      key: "vHandoverLocationCountry",
      label: "vHandoverLocationCountry",
      value: "Deutschland",
      type: "text",
      prefixIcon: CountryIconChild,
      parentKey: "locationVehicleHandover",
      dropdownType: "country",
    },
  ],
  vehicleReturnLocation: [
    {
      id: null,
      key: "vReturnLocationStreet",
      label: "vReturnLocationStreet",
      value: "",
      type: "text",
      prefixIcon: StreetIconChild,
      parentKey: "vehicleReturnLocation",
    },
    {
      id: null,
      key: "vReturnLocationHouse",
      label: "vReturnLocationHouse",
      value: "",
      type: "text",
      prefixIcon: HouseIconChild,
      parentKey: "vehicleReturnLocation",
    },
    {
      id: null,
      key: "vReturnLocationZipCode",
      label: "vReturnLocationZipCode",
      value: "",
      type: "text",
      prefixIcon: ZipCodeChildIcon,
      parentKey: "vehicleReturnLocation",
    },
    {
      id: null,
      key: "vReturnLocationCity",
      label: "vReturnLocationCity",
      value: "",
      type: "dropdown",
      prefixIcon: CityIconChild,
      parentKey: "vehicleReturnLocation",
      dropdownType: "city",
    },
    {
      id: null,
      key: "vReturnLocationState",
      label: "vReturnLocationState",
      value: "",
      type: "dropdown",
      prefixIcon: StateIconChild,
      parentKey: "vehicleReturnLocation",
      dropdownType: "state",
    },
    {
      id: null,
      key: "vReturnLocationCountry",
      label: "vReturnLocationCountry",
      value: "Deutschland",
      type: "text",
      prefixIcon: CountryIconChild,
      parentKey: "vehicleReturnLocation",
      dropdownType: "country",
    },
  ],
  accidentSite: [
    {
      id: null,
      key: "accidentLocationStreet",
      label: "accidentLocationStreet",
      value: "",
      type: "text",
      prefixIcon: StreetIconChild,
      parentKey: "accidentSite",
    },
    {
      id: null,
      key: "accidentLocationHouse",
      label: "accidentLocationHouse",
      value: "",
      type: "text",
      prefixIcon: HouseIconChild,
      parentKey: "accidentSite",
    },
    {
      id: null,
      key: "accidentLocationZipCode",
      label: "accidentLocationZipCode",
      value: "",
      type: "text",
      prefixIcon: ZipCodeChildIcon,
      parentKey: "accidentSite",
    },
    {
      id: null,
      key: "accidentLocationCity",
      label: "accidentLocationCity",
      value: "",
      type: "dropdown",
      prefixIcon: CityIconChild,
      parentKey: "accidentSite",
      dropdownType: "city",
    },

    {
      id: null,
      key: "accidentLocationState",
      label: "accidentLocationState",
      value: "",
      type: "dropdown",
      prefixIcon: StateIconChild,
      parentKey: "accidentSite",
      dropdownType: "state",
    },

    {
      id: null,
      key: "accidentLocationCountry",
      label: "accidentLocationCountry",
      value: "Deutschland",
      type: "text",
      prefixIcon: CountryIconChild,
      parentKey: "accidentSite",
      dropdownType: "country",
    },
  ],
};

export const formFields = [
  {
    id: 1,
    key: "competentCourt",
    label: "Competent Court",
    value: "",
    // inputType: "dropdown",
    type: "dropdown",
    InputSuffixIcon: CourtIcon,
    dropdownType: "competentCourt",
    required: true,
  },
  {
    id: 2,
    key: "insurer",
    label: "Insurer",
    value: "",
    type: "dropdown",
    dropdownType: "insurer",
    InputSuffixIcon: InsuranceCarIcon,
    note: "(Note: Full name of the insurance company, e.g., HUK 24, HUK-Allgemeine)",
  },
  {
    id: 3,
    key: "amountClaimed",
    label: "Amount claimed in EUR",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 4,
    key: "deadline",
    label: "Final payment deadline Smile + 1 day",
    value: "",
    InputSuffixIcon: CalenderIconNew,
    type: "date",
  },
  {
    id: 5,
    key: "customerName",
    label: "Customer Name",
    value: "",
    type: "text",
    InputSuffixIcon: null,
    note: "(Note: first name + last name or company name)",
    isParent: true,
    // childs: childKeys.customerName,
    sections: [
      {
        sectionLabel: "customerSingle",
        childs: childKeys.customerName,
      },
      {
        sectionLabel: "address",
        childs: childKeys.customerAddress,
      },
    ],
  },

  {
    id: 6,
    key: "dayOfAccident",
    label: "Day of The Accident",
    value: "",
    InputSuffixIcon: CalenderIconNew,
    type: "date",
    allow: "tillToday",
  },
  {
    id: 7,
    key: "accidentSite",
    label: "Accident Site",
    value: "",
    type: "text",
    InputSuffixIcon: AddressIcon,
    isParent: true,
    // childs: childKeys.accidentSite,
    sections: [
      {
        sectionLabel: "accidentSite",
        childs: childKeys.accidentSite,
      },
    ],
  },
  {
    id: 8,
    key: "platNumber",
    label: "License plate number of the vehicle that caused the accident",
    value: "",
    type: "text",
    InputSuffixIcon: LicensePlateIcon,
  },

  {
    id: 9,
    key: "demageInsuranceNumber",
    label: "Damage No. Insurance",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },

  {
    id: 10,
    key: "modelVehicleUF",
    label: "Model accident vehicle customer (UF)",
    value: "",
    type: "text",
    InputSuffixIcon: ModelCarIcon,
    isParent: true,
    sections: [
      {
        sectionLabel: "modelVehicleUF",
        childs: childKeys.modelVehicleUF,
      },
    ],
  },
  {
    id: 11,
    key: "displacementUF",
    label: "Displacement ccm UF",
    value: "",
    type: "text",
    InputSuffixIcon: CarDisplacementIcon,
  },
  {
    id: 12,
    key: "kwUF",
    label: "KW UF",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },
  {
    id: 13,
    key: "carRentalUF",
    label: "Car rental class UF",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },
  {
    id: 14,
    key: "rentalBillingSmile",
    label: "Car rental class billing Smile",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },
  {
    id: 15,
    key: "startLeaseDate",
    label: "Start of lease (date)",
    value: "",

    InputSuffixIcon: CalenderIconNew,
    type: "date",
  },
  {
    id: 16,
    key: "endLeaseDate",
    label: "End of lease (date)",
    value: "",

    InputSuffixIcon: CalenderIconNew,
    type: "date",
  },
  {
    id: 17,
    key: "rentalDays",
    label: "Rental days",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },
  {
    id: 18,
    key: "invoiceAmountSmile",
    label: "Invoice amount Smile",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 19,
    key: "insuranceDate",
    label: "Payment(s) Insurance with date",
    value: "",

    InputSuffixIcon: CalenderIconNew,
    type: "date",
  },
  {
    id: 20,
    key: "lastReminderDate",
    label: "Date of last reminder Smile",
    value: "",

    InputSuffixIcon: CalenderIconNew,
    type: "date",
  },
  {
    id: 21,
    key: "finalReminderDeadline",
    label: "Date deadline for final reminder Smile",
    value: "",

    InputSuffixIcon: CalenderIconNew,
    type: "date",
  },
  {
    id: 22,
    key: "postCodeArea",
    label: "Post Code Area",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },
  {
    id: 23,
    key: "schwackeFlatRate",
    label: "Amount Schwacke flat rate",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 24,
    key: "schwackePerDay",
    label: "Amount Schwacke / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 25,
    key: "schwackeRentalPeriod",
    label: "Amount Schwacke rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 26,
    key: "fraunhoferFlatRate",
    label: "Amount Fraunhofer flat rate",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 27,
    key: "amountFraunhoferPerDay",
    label: "Amount Fraunhofer / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 28,
    key: "amountFraunhoferRental",
    label: "Amount Fraunhofer / Rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 29,
    key: "amountFracke",
    label: "Amount Fracke (Schwacke)",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 30,
    key: "amount20Surcharge",
    label: "Amount 20% surcharge",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 31,
    key: "liabilityReductionPerDay",
    label: "Amount of bond reduction / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 32,
    key: "reductionRentalPeriod",
    label: "Amount Liability reduction Rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },

  {
    id: 33,
    key: "winterTiresPerDay",
    label: "Amount for winter tires / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 34,
    key: "amountWinterTires",
    label: "Amount Winter tires / Rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 35,
    key: "amountDelivery",
    label: "Amount Delivery",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 36,
    key: "amountPickup",
    label: "Amount Pickup",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 37,
    key: "naviPerDay",
    label: "Amount Navi / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 38,
    key: "amountNavigation",
    label: "Amount Navigation system / Rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 39,
    key: "additionalDriversPerDay",
    label: "Amount for additional drivers / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 40,
    key: "amountAdditionalDriver",
    label: "Amount Additional driver / Rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 41,
    key: "coupingPerDay",
    label: "Amount Trailer coupling / per day",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },
  {
    id: 42,
    key: "amountTrailerCouping",
    label: "Amount Trailer coupling / Rental period",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },

  {
    id: 43,
    key: "calculationClaim",
    label: "Fracke (Schwacke) calculation claim",
    value: "",
    type: "number",
    InputSuffixIcon: EuroIcon,
  },

  {
    id: 44,
    key: "taxDeductionEntitled",
    label: "Input tax deduction entitlement Customer",
    value: "",
    type: "text",
    InputSuffixIcon: null,
  },

  {
    id: 45,
    key: "locationVehicleHandover",
    label: "Location Vehicle handover",
    value: "",
    type: "text",
    InputSuffixIcon: AddressIcon,
    isParent: true,
    required: true,
    sections: [
      {
        sectionLabel: "locationVehicleHandover",
        childs: childKeys.locationVehicleHandover,
      },
    ],
  },
  {
    id: 46,
    key: "vehicleReturnLocation",
    label: "Vehicle return location",
    value: "",
    type: "text",
    required: true,
    InputSuffixIcon: AddressIcon,
    isParent: true,
    // childs: childKeys.vehicleReturnLocation,
    sections: [
      {
        sectionLabel: "vehicleReturnLocation",
        childs: childKeys.vehicleReturnLocation,
      },
    ],
  },

  {
    id: 47,
    key: "additionalDriverName",
    label: "Name of additional driver + relationship to customer",
    value: "",
    type: "text",
    InputSuffixIcon: null,
    isParent: true,
    // childs: childKeys.additionalDriverName,
    sections: [
      {
        sectionLabel: "nameOfDriver",
        childs: childKeys.additionalDriverName,
      },
      {
        sectionLabel: "relationToCustomer",
        childs: childKeys.relationToCustomer,
      },
    ],
  },
];

export const sectionsOfForm = {
  customerDetails: ["customerName", "additionalDriverName"],
  contractDetails: [
    "modelVehicleUF",
    "platNumber",
    "startLeaseDate",
    "endLeaseDate",
    "locationVehicleHandover",
    "vehicleReturnLocation",
    "rentalDays",
    "invoiceNoSmile",
    "invoiceDateSmile",
    "invoiceAmountSmile",
    "amountWinterTires",
    "winterTiresPerDay",
    "amountDelivery",
    "amountPickup",
    "naviPerDay",
    "amountNavigation",
    "additionalDriversPerDay",
    "amountAdditionalDriver",
    "coupingPerDay",
    "amountTrailerCouping",
    "taxDeductionEntitled",
    "liabilityReductionPerDay",
    "reductionRentalPeriod",
  ],
  accident: [
    "competentCourt",
    "dayOfAccident",
    "accidentSite",
    "insurer",
    "nameOfPolicyholder",
    "demageInsuranceNumber",
  ],
  // whoCausedAccident: [],
  // whoGotAffected: ["modelVehicleUF", "platNumber", ],
  claim: [
    "amountClaimed",
    "deadline",
    "insuranceDate",
    "lastReminderDate",
    "finalReminderDeadline",
    "postCodeArea",
    "schwackeFlatRate",
    "schwackePerDay",
    "schwackeRentalPeriod",
    "fraunhoferFlatRate",
    "amountFraunhoferPerDay",
    "amountFraunhoferRental",
    "amountFracke",
    "amount20Surcharge",
    "calculationClaim",
  ],
};

export const formFieldsSectionTabs = [
  "customerDetails",
  "contractDetails",
  "accident",
  "claim",
];

export const formData = {
  competentCourt: "",
  insurer: "",
  amountClaimed: "",
  deadline: "", //no 4 final payment deadline
  customerName: "",
  address: "",
  street: "",
  city: "",
  country: "",
  dayOfAccident: "",
  accidentSite: "",
  platNumber: "",
  demageInsuranceNumber: "",
  modelVehicleUF: "",
  displacementUF: "",
  kwUF: "",
  carRentalUF: "",
  rentalBillingSmile: "",
  startLeaseDate: "",
  endLeaseDate: "",
  rentalDays: "",
  invoiceAmountSmile: "",
  insuranceDate: "",
  lastReminderDate: "",
  finalReminderDeadline: "",
  postCodeArea: "",
  schwackeFlatRate: "",
  schwackePerDay: "",
  schwackeRentalPeriod: "",
  fraunhoferFlatRate: "",
  amountFraunhoferPerDay: "",
  amountFraunhoferRental: "",
  amountFracke: "",
  amount20Surcharge: "",
  liabilityReductionPerDay: "", //31
  reductionRentalPeriod: "", //32
  winterTiresPerDay: "",
  amountWinterTires: "", //rental
  amountDelivery: "",
  amountPickup: "",
  naviPerDay: "", //per day
  amountNavigation: "", //rental
  additionalDriversPerDay: "",
  amountAdditionalDriver: "", //rental
  coupingPerDay: "",
  amountTrailerCouping: "",
  calculationClaim: "",
  taxDeductionEntitled: "",
  locationVehicleHandover: "",
  vehicleReturnLocation: "",
  additionalDriverName: "",
  nameOfDriver: "",
  relationToCustomer: "",
  vReturnLocationCountry: "",
  vReturnLocationCity: "",
  vReturnLocationState: "",
  vReturnLocationZipCode: "",
  vReturnLocationStreet: "",
  vHandoverLocationCountry: "",
  vHandoverLocationCity: "",
  vHandoverLocationState: "",
  vHandoverLocationZipCode: "",
  vHandoverLocationStreet: "",
  accidentLocationCountry: "",
  accidentLocationCity: "",
  accidentLocationState: "",
  accidentLocationZipCode: "",
  accidentLocationStreet: "",
  driverFirstName: "",
  driverLastName: "",
  vHandoverLocationHouse: "",
  vReturnLocationHouse: "",
  accidentLocationHouse: "",
};

export const dateKeys = [
  "deadline",
  "dayOfAccident",
  "insuranceDate",
  "lastReminderDate",
  "finalReminderDeadline",
  "startLeaseDate",
  "endLeaseDate",
  "invoiceDateSmile",
];

export const dropdownKeys = [
  "insurer",
  "competentCourt",
  "city",
  "carCompany",
  "carModel",
  "vReturnLocationCountry",
  "vHandoverLocationCity",
];
export const arrOfAssets = [
  "rentalAgreement", //Mietvertrag
  "smileInvoice", //Rechnung Smile
  "declarationAssignment", //Abtretungserklärung
  "accidentReport", //Unfallmitteilung
  "damageAssessment", //Schadengutachten
  "rentalAppendicesPOA", //Anhänge zum Mietvertrag (Vollmacht)
  "repairConfirmation", //Reparaturbestätigung
  "repairSchedule", //Reparaturablaufplan
  "proofNewPurchase", //Nachweis Neuanschaffung
  "approvalRentalAgreement", //Zulassung Mietvertrag
  "paymentReductionLetter", //Schreiben Vers. zu Zahlungen / Kürzungen
  "insuranceEmailWithAttachments", //Schreiben Mail Smile an Versicherung (+Anlagen)
  "settlementOfferResponseSmile", //Vergleichsangebot Vers. + Antwort Smile
  "settlementOfferResponseVersion", //Vergleichsangebot Smile + Antwort Vers.
  "customerRepresentativeCorrespondence", //Korrespondenz Kundenanwalt
  "schwackeRatings", //Schwacke-Bewertungen
  "dbgkInvolved", //Deutsche Büro Grüne Karte (DBGK) involviert
  "auditReportInsurance", //Prüfbericht Versicherung
  "rentalPeriodOver20Days", //Mietdauer über 20 Tage
  "otherDocuments", //Sonstige Unterlagen
];
export const localAssetsObj = {
  rentalAgreement: "rentalAgreement", // Mietvertrag
  smileInvoice: "smileInvoice", // Rechnung Smile
  declarationAssignment: "declarationAssignment", // Abtretungserklärung
  accidentReport: "accidentReport", // Unfallmitteilung
  damageAssessment: "damageAssessment", // Schadengutachten
  rentalAppendicesPOA: "rentalAppendicesPOA", // Anhänge zum Mietvertrag (Vollmacht)
  repairConfirmation: "repairConfirmation", // Reparaturbestätigung
  repairSchedule: "repairSchedule", // Reparaturablaufplan
  proofNewPurchase: "proofNewPurchase", // Nachweis Neuanschaffung
  approvalRentalAgreement: "approvalRentalAgreement", // Zulassung Mietvertrag
  paymentReductionLetter: "paymentReductionLetter", // Schreiben Vers. zu Zahlungen / Kürzungen
  insuranceEmailWithAttachments: "insuranceEmailWithAttachments", // Schreiben Mail Smile an Versicherung (+Anlagen)
  settlementOfferResponseSmile: "settlementOfferResponseSmile", // Vergleichsangebot Vers. + Antwort Smile
  settlementOfferResponseVersion: "settlementOfferResponseVersion", // Vergleichsangebot Smile + Antwort Vers.
  customerRepresentativeCorrespondence: "customerRepresentativeCorrespondence", // Korrespondenz Kundenanwalt
  schwackeRatings: "schwackeRatings", // Schwacke-Bewertungen
  dbgkInvolved: "dbgkInvolved", // Deutsche Büro Grüne Karte (DBGK) involviert
  auditReportInsurance: "auditReportInsurance", // Prüfbericht Versicherung
  rentalPeriodOver20Days: "rentalPeriodOver20Days", // Mietdauer über 20 Tage
  otherDocuments: "otherDocuments", // Sonstige Unterlagen
};

const undieOptions = [
  {
    label: "JA",
    value: "yes",
  },
  {
    label: "Nein",
    value: "no",
  },
];
const damageTypeOptions = [
  {
    label: "Totalschaden",
    value: "total",
  },
  {
    label: "Reparatur",
    value: "repair",
  },
];
export const clientMasterData = [
  {
    key: "FileReferenceSmile",
    label: "File reference Smile:",
    value: "",
    LabelIcon: FileRefrenceIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    disabled: true,
  },
  {
    key: "licensePlateSmile",
    label: "License plate Smile",
    value: "",
    LabelIcon: LicensePlateSmileIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },
  {
    key: "claimNumber",
    label: "Claim Number",
    value: "",
    LabelIcon: CustomerNumberIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },
  {
    key: "administrativeAssistantSmile",
    label: "Administrative assistant Smile",
    value: "",
    LabelIcon: AssistantIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },
  {
    key: "attorney",
    label: "Attorney",
    value: "",
    LabelIcon: AttorneyIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    required: true,
  },

  {
    key: "invoiceNoSmile",
    label: "Invoice no. Smile",
    value: "",
    LabelIcon: InvoiceNumberIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },

  {
    key: "customerNoSmile",
    label: "Customer No. Smile",
    value: "",
    LabelIcon: CustomerNumberIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },

  {
    key: "intermediary",
    label: "Intermediary",
    value: "",
    LabelIcon: Intermediary,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    required: true,
  },
  {
    key: "createdBy",
    label: "Created By",
    value: "",
    LabelIcon: CreatedByMasterIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    disabled: true,
  },
  {
    key: "UNDIE",
    label: "UNDIE",
    value: "",
    LabelIcon: UndieIcon,
    inputType: "radio",
    type: "radio",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    dropdownList: undieOptions,
  },
  {
    key: "invoiceDateSmile",
    label: "Invoice date Smile",
    value: "",
    LabelIcon: InvoiceDateIcon,
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    InputSuffixIcon: CalenderIconNew,
    type: "date",
    inputType: "date",
  },
  {
    key: "customerId",
    label: "Customer ID",
    value: "",
    LabelIcon: CustomerIdIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },
  {
    key: "insurance",
    label: "Insurance",
    value: "",
    LabelIcon: FormInsuranceIcon,
    inputType: "text",
    type: "text",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
  },

  // {
  //   key: "nameOfPolicyholder",
  //   label: "Name of policyholder",
  //   value: "",
  //   LabelIcon: PolicyHolderIcon,
  //   inputType: "text",
  //   type: "text",
  //   inputPostFixIcon: "icon",
  //   isClientMasterData: true,
  // },
  {
    key: "caseCreationDate",
    label: "Date the case was created",
    value: "",
    LabelIcon: CreatedByDateMasterIcon,
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    type: "date",
    inputType: "date",
    disabled: true,
  },

  {
    key: "typeOfDamage",
    label: "Type of damage",
    value: "",
    LabelIcon: TypeOfDamage,
    inputType: "radio",
    type: "radio",
    inputPostFixIcon: "icon",
    isClientMasterData: true,
    dropdownList: damageTypeOptions,
  },
];

export const dropdownAddItemError = {
  city: "cityNameRequired",
  state: "stateNameRequired",
};
export const dropdownAddItemEndPoints = {
  city: "/add_city",
  insurer: "/add_insurance_company",
};
export const dropdownAddItemKeyNameForPayload = {
  city: "city",
  insurer: "companyName",
};
